/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'
import { Icon } from '../../utils/Icon'
import { VStack } from './VStack'
import { Horizon } from '../map_facilities/Horizon'

export type BasicInfoProps = {
  attachedClinic?: string
  name: string
  phoneNumber: string
  openingTimes: string[]
  childCapacityCount: number
  roomCount: number
  basicPrice: string
  distance: number | null
  mapUrl?: string
}

export const BasicInfo = ({
  attachedClinic,
  name,
  phoneNumber,
  openingTimes,
  childCapacityCount,
  roomCount,
  basicPrice,
  distance,
  mapUrl,
}: BasicInfoProps) => {
  return (
    <div css={basicInfoStyle}>
      {attachedClinic && attachedClinic.length > 0 && (
        <p className="attachedClinic">{attachedClinic} 併設</p>
      )}
      <h1>{name}</h1>
      <VStack gap="10px">
        <Horizon display="flex" columnGap="5px">
          <Icon iconName={'phone'} style={{ width: '14px', height: '14px' }} />
          <a className="tel" href={`tel:${phoneNumber}`}>
            {phoneNumber}
          </a>
        </Horizon>
        <Horizon display="flex" columnGap="5px">
          <Icon
            iconName={'time'}
            style={{
              width: '14px',
              height: '14px',
              alignSelf: 'start',
              marginTop: '3px',
            }}
          />
          <span>
            {openingTimes.map((item, i) => {
              const slash = i === openingTimes.length - 1 ? '' : '／'
              return (
                <span
                  key={`${i}_${item}`}
                  css={css`
                    display: inline-block;
                  `}
                >
                  {item} {slash}
                </span>
              )
            })}
          </span>
        </Horizon>
        <Horizon display="flex" columnGaps={[5, 5, 20, 5, 5]}>
          <Icon iconName={'baby'} style={{ width: '14px', height: '14px' }} />
          <b>定員</b>
          <span>{childCapacityCount}人</span>
          <Icon iconName={'house'} style={{ width: '14px', height: '14px' }} />
          <b>部屋数</b>
          <span>{roomCount}部屋</span>
        </Horizon>
        <Horizon display="flex" columnGap="5px">
          <Icon
            iconName={'money_yen'}
            style={{ width: '14px', height: '14px' }}
          />
          <b>基本料金</b>
          <span>{basicPrice}</span>
        </Horizon>
        <Horizon display="flex" columnGaps={[5, 10]}>
          <Icon
            iconName={'location_on'}
            style={{ width: '14px', height: '14px' }}
          />
          {distance !== null && <span>自宅から {distance}km</span>}
          {mapUrl && (
            <a
              className="mapLink"
              href={mapUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              地図アプリで見る
            </a>
          )}
        </Horizon>
      </VStack>
    </div>
  )
}

const basicInfoStyle = css`
  padding: 24px 20px;
  display: grid;

  & h1 {
    font-weight: bold;
    font-size: 20px;
    line-height: 160%;
    margin-bottom: 25px;
  }

  & .attachedClinic {
    font-weight: bold;
    font-size: 12px;
    line-height: 160%;
    color: #3f3d35;
  }
  & .tel {
    letter-spacing: 0.05em;
    text-decoration-line: underline;

    &:visited,
    &:link {
      color: inherit;
    }
  }
  & .mapLink {
    background-color: #f6f5f4;
    padding: 4px 15px;
    font-size: 12px;
    line-height: 100%;
    text-decoration: none;
    color: #eb2d23;
    border: 1px solid #eb2d23;
    box-sizing: border-box;
    border-radius: 20px;
  }
`
